import React from "react";
import Footer from "../components/Shared/Footer";
import AboutBottomComponent from "../components/Shared/AboutBottomImages";


const AboutUs = () => {
  return (
    <div>


      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>About Us</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">About Us</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-6 col-12">
              <div className="row g-sm-4 g-2">
                <div className="col-6">
                  <div className="fresh-image-2 ">
                    <div
                      className="bg-size blur-up lazyloaded"
                      style={{
                        backgroundImage:
                          "url(../assets/images/Whoweare/who_w_r_1.jpg)",
                        backgroundSize: "cover",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        display: "block",
                      }}
                    ></div>
                  </div>
                </div>

                <div className="col-6">
                  <div className="fresh-image " >
                    <div
                      className="bg-size blur-up lazyloaded"
                      style={{
                        backgroundImage:
                          "url(../assets/images/Whoweare/who_w_r_2.jpg)",
                        backgroundSize: "cover",
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        display: "block",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-12">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="review-title">
                    <h1 className="font-lg mb-3">
                      Who We Are ?
                    </h1>


                  </div>

                  <div className="delivery-list">
                    <p className="font-xsm justify_content">
                      Zantus is a budding start up founded by nutrition experts having vast bio pharma and nutraceutical
                      experience. With strong focus on Care, Creativity and
                      Compliance, it thrives on collaboration, transparency and
                      continuous improvement.  It works with diverse
                      stakeholders in scientific nutrition space to bridge
                      different perspectives.
                    </p>
                    <p className="font-xsm justify_content">
                      Zantus is committed to provide high-quality,
                      science-backed nutrition products and guidance, fostering
                      a healthier & vibrant world. It aspires to partner with
                      stakeholders to create a favorable ecosystem to bridge the
                      gap between awareness & implementation with knowledge
                      partnering securing business interests, risk management,
                      and innovative solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="client-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="  font-lg mb-5 text-center">
                <h1 className="font-lg mb-3">
                  Our mission & vision
                </h1>


              </div>

              <div className="row">
                <div className="col-xl-6 d-flex justify-content-center mb-3">
                  <div className="clint-contain  width_card_mission hover-box" >
                    <div className="client-icon">
                      <img
                        src="../assets/svg/mission_icon.svg"
                        className="blur-up lazyload"
                        alt=""
                      />
                    </div>

                    <div className="font-lmd fw-semibold">Mission</div>
                    <p className="">
                      Zantus aspires to partner with stakeholders to create a favourable ecosystem to bridge the gap between awareness & implementation with knowledge partnering, securing business interests, risk management, and innovative solutions.
                    </p>
                  </div>
                </div>

                <div className="col-xl-6 d-flex justify-content-center mb-3">
                  <div className="clint-contain width_card_mission hover-box">
                    <div className="client-icon">
                      <img
                        src="../assets/svg/vision_icon.svg"
                        className="blur-up lazyload"
                        alt=""
                      />
                    </div>

                    <div className="font-lmd fw-semibold">Vision</div>
                    <p>
                      Zantus is committed to provide high-quality, science-backed nutrition wellness products and services, fostering a healthier & vibrant world.

                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section></section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-xl-6 ">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="review-title mb-3">
                    <h1 className="font-lg mb-3">
                      Platforms
                    </h1>


                  </div>

                  <div className="delivery-list">
                    <div className="font-sm mb-4 fw-semibold"> It operates under a three platforms namely :</div>


                    <div className="font-md">
                      <ul className="custom-list text-muted">

                        <div>
                          <li className="d-flex gap-2 align-items-center font-sm  mb-2">
                            <span className="bullet_point_black"></span> <span className="font-xsm fw-semibold">NutraBridge</span>
                          </li>
                          <p>
                            To conceptualize and commercialize innovative nutrition products
                          </p>
                        </div>

                        <div>
                          <li className="d-flex gap-2 align-items-center font-sm mb-2">
                            <span className="bullet_point_black"></span>  <span className="font-xsm fw-semibold ">Socium</span>
                          </li>
                          <p>For knowledge partnership with nutraceutical, herbal, ayurvedic and wellness industry for creative and compliant solutions</p>
                        </div>

                        <div>
                          <li className="d-flex gap-2 align-items-center font-sm mb-2">
                            <span className="bullet_point_black"></span>  <span className="font-xsm fw-semibold">Securus</span>
                          </li>
                          <p>For Risk Management for forward planning preparing businesses in evolving landscape.</p>

                        </div>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 ">
              <div className="">
                <AboutBottomComponent/>


              </div>
            </div>

          </div>
        </div>
      </section>

      <div>
        <Footer />
      </div>




    </div>
  );
};

export default AboutUs;
